<template>
  <section class="gallery">
    <h2>Photo Gallery</h2>

    <div class="masonry-grid">
      <img
        v-for="(photo, index) in photoUrls"
        :key="index"
        :src="photo"
        loading="lazy"
        class="masonry-item"
        @click="openLightbox(index)"
        alt="Wedding Photo"
      />
    </div>

    <!-- Lightbox -->
    <div v-if="showLightbox" class="lightbox" @click.self="closeLightbox">
      <img
        :src="photoUrls[currentIndex]"
        class="lightbox-img fade"
        ref="lightboxImage"
      />

      <button class="nav prev" @click.stop="prevPhoto">&#10094;</button>
      <button class="nav next" @click.stop="nextPhoto">&#10095;</button>
      <button class="close-btn" @click="closeLightbox">&times;</button>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      localPhotos: [],
      externalPhotos: [],
      showLightbox: false,
      currentIndex: 0,

      startX: 0,
      isDragging: false
    };
  },

  created() {
    const importer = require.context(
      "../assets/image",
      false,
      /\.(png|jpe?g|webp)$/i
    );

    this.externalPhotos = importer.keys().map((file) => {
      const module = importer(file);
      return module.default || module;
    });
  },

  computed: {
    photoUrls() {
      return [...this.localPhotos, ...this.externalPhotos];
    }
  },

  methods: {
    openLightbox(index) {
      this.currentIndex = index;
      this.showLightbox = true;

      window.addEventListener("keydown", this.handleKey);

      this.$nextTick(() => {
        const img = this.$refs.lightboxImage;

        img.addEventListener("touchstart", this.touchStart, { passive: true });
        img.addEventListener("touchend", this.touchEnd, { passive: true });

        img.addEventListener("mousedown", this.dragStart);
        img.addEventListener("mouseup", this.dragEnd);
      });
    },

    closeLightbox() {
      this.showLightbox = false;
      window.removeEventListener("keydown", this.handleKey);
    },

    prevPhoto() {
      this.currentIndex =
        (this.currentIndex - 1 + this.photoUrls.length) %
        this.photoUrls.length;
    },

    nextPhoto() {
      this.currentIndex = (this.currentIndex + 1) % this.photoUrls.length;
    },

    handleKey(e) {
      if (!this.showLightbox) return;

      if (e.key === "ArrowRight") this.nextPhoto();
      if (e.key === "ArrowLeft") this.prevPhoto();
      if (e.key === "Escape") this.closeLightbox();
    },

    touchStart(e) {
      this.startX = e.changedTouches[0].clientX;
    },
    touchEnd(e) {
      const diff = e.changedTouches[0].clientX - this.startX;
      if (diff > 50) this.prevPhoto();
      if (diff < -50) this.nextPhoto();
    },

    dragStart(e) {
      this.isDragging = true;
      this.startX = e.clientX;
    },
    dragEnd(e) {
      if (!this.isDragging) return;
      const diff = e.clientX - this.startX;

      if (diff > 50) this.prevPhoto();
      if (diff < -50) this.nextPhoto();

      this.isDragging = false;
    }
  }
};
</script>

<style scoped>
.gallery {
  text-align: center;
  min-height: 60vh;
  padding-top: 10px;
}

/* YOUR ORIGINAL GRID — UNCHANGED */
.masonry-grid {
  column-count: 3;
  column-gap: 8px;
  padding: 10px;
}

.masonry-item {
  width: 100%;
  margin-bottom: 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.3s ease;
}
.masonry-item:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
}

/* Lightbox */
.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.lightbox-img {
  max-width: 90%;
  max-height: 90vh;
  border-radius: 10px;
  user-select: none;
}

/* Fade animation */
.fade {
  animation: fadeIn 0.25s ease;
}
@keyframes fadeIn {
  from { opacity: 0.4; }
  to { opacity: 1; }
}

.close-btn {
  position: absolute;
  top: 30px;
  right: 40px;
  font-size: 3rem;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
}

.nav {
  position: absolute;
  top: 50%;
  font-size: 3rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  user-select: none;
}
.prev { left: 20px; }
.next { right: 20px; }
</style>
